module.exports = __webpack_public_path__ + "phone.56d04cb351e85ced05a71b1057d348a4.png";